import { render } from "./InputInstructor.vue?vue&type=template&id=5dffaa4c"
import script from "./InputInstructor.vue?vue&type=script&lang=ts"
export * from "./InputInstructor.vue?vue&type=script&lang=ts"
script.render = render

export default script